export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-2048w.267838ff.webp";